module.exports = __webpack_public_path__ + "media/images/sarapoint/a-point-ef67bf711ace14c97e1f2ea8fa11da1d.png";